
import React, { useState, useContext } from "react";
import SimpleBar from 'simplebar-react';
import { useLocation } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faBoxOpen, faChartPie, faCog, faFileAlt, faHandHoldingUsd, faSignOutAlt, faTable, faTimes, faCalendarAlt, faMapPin, faInbox, faRocket, faUser, faUpload, faBars, faCheckCircle, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "../../utils/AuthContext";
import { useNavigate } from "react-router-dom";
import { Nav, Badge, Image, Button, Dropdown, Accordion, Navbar, ButtonGroup } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { UnreadContext } from "../../utils/UnreadContext";
import i18n from "../../i18n";
import { RoutesCustom } from "../../routes";
import Inkasso from "../../assets/logo.webp";
export default (props = {}) => {
  const { unreadClaims } = useContext(UnreadContext);
  const location = useLocation();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const showClass = show ? "show" : "";
  const navigate = useNavigate();
  const { endImpersonation, logout, role, user } = useContext(AuthContext);
  const handleLogout = async () => {


    if (localStorage.getItem("adminToken")) {
      // ✅ End impersonation using context
      const restored = await endImpersonation();

      if (restored) {
        navigate("/admin/dashboard-overview"); // back to admin panel
      } else {
        navigate("/"); // fallback
      }
    } else {
      // ✅ Normal logout
      await logout();
      navigate("/");
    }
  };
  console.log("Unread Claims", unreadClaims);
  const isSubUser = !!user.parentUser; // true if parentUser exists





  const onCollapse = () => setShow(!show);

  const CollapsableNavItem = (props) => {
    const { eventKey, title, icon, children = null } = props;
    const defaultKey = pathname.indexOf(eventKey) !== -1 ? eventKey : "";

    return (
      <Accordion as={Nav.Item} defaultActiveKey={defaultKey}>
        <Accordion.Item eventKey={eventKey}>
          <Accordion.Button as={Nav.Link} className="d-flex justify-content-between align-items-center">
            <span>
              <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span>
              <span className="sidebar-text">{title}</span>
            </span>
          </Accordion.Button>
          <Accordion.Body className="multi-level">
            <Nav className="flex-column">
              {children}
            </Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };

  const NavItem = ({ title, link, external, target, icon, image, badgeText, badgeBg = "secondary", badgeColor = "primary", onClick }) => {
    const classNames = badgeText ? "d-flex justify-content-start align-items-center justify-content-start" : "";
    const navItemClassName = link === pathname ? "active" : "";


    // Action-only item (like Logout)
    if (!link) {
      return (
        <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
          <Button
            variant="link"
            className={classNames + " text-start w-100 text-white ps-3"}
            onClick={onClick}
          >
            {icon && <span className="sidebar-icon me-3"><FontAwesomeIcon icon={icon} /></span>}
            <span className="sidebar-text">{title}</span>
          </Button>
        </Nav.Item>
      );
    }

    // Normal nav link
    const linkProps = external ? { href: link, rel: "noreferrer" } : { as: Link, to: link };

    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        <Nav.Link {...linkProps} target={target} className={classNames} onClick={onClick}>
          {icon && <span className="sidebar-icon me-2"><FontAwesomeIcon icon={icon} /></span>}
          {image && <Image src={image} width={20} height={20} className="sidebar-icon svg-icon" />}
          <span className="sidebar-text">{title}</span>
          {badgeText && (
            <Badge pill bg={badgeBg} text={badgeColor} className="badge-md notification-count ms-2">{badgeText}</Badge>
          )}
        </Nav.Link>
      </Nav.Item>
    );
  };


  return (
    <>
      <Navbar expand={false} collapseOnSelect variant="dark" className="navbar-theme-primary px-4 d-md-none">

        <Navbar.Brand className="me-lg-5" >
          <Image
            src={Inkasso}
            alt="Inkasso log"
            style={{ height: "50px", filter: "brightness(0) invert(0)" }}
            className="navbar-brand-light"
          />

        </Navbar.Brand>
        <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar
          className={`collapse ${showClass} sidebar d-md-block bg-primary text-white h-100
    ${props.isSidebarOpen ? "desktop-open" : "desktop-collapsed"}`}
        >

          <div
            className={`sidebar-inner pt-3 d-flex flex-column h-100`}
            style={{
              paddingLeft: props.isSidebarOpen ? "1.5rem" : "0.7rem",
              paddingRight: props.isSidebarOpen ? "1.5rem" : "1.5rem"
            }}
          >

            <div
              className="d-none d-md-flex mb-3"
              style={{
                justifyContent: props.isSidebarOpen ? "flex-end" : "center",
              }}
            >

              <Button
                variant="link"
                className="text-white p-1"
                onClick={() => props.setIsSidebarOpen(!props.isSidebarOpen)}
              >
                <FontAwesomeIcon icon={faBars} />
              </Button>
            </div>
            {/* user card */}
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
              <div className="d-flex align-items-center">
                <div className="user-avatar lg-avatar me-4">

                </div>
              </div>
              <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>

            {/* main nav links */}
            <Nav className="flex-column pt-3 pt-md-0">
              {/* Logo */}
              <div className="sidebar-logo">
                {/* Desktop */}
                <div className="d-none d-md-flex justify-content-center">
                  {props.isSidebarOpen ? (
                    <Image
                      src={Inkasso}
                      alt="Inkasso log"
                      style={{ marginBottom: "20px", filter: "brightness(0) invert(0)" }}
                      className="navbar-brand-light"
                    />
                  ) : (
                    <span
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "bold",
                        color: "black",
                        display: "inline-block",
                        width: "50px",
                        height: "50px",
                        lineHeight: "50px",
                        textAlign: "center",
                        borderRadius: "8px",
                        marginRight: "10px"
                      }}
                    >
                      N
                    </span>
                  )}
                </div>

                {/* Mobile */}
                <div className="d-flex d-md-none justify-content-start">
                  <Image
                    src={Inkasso}
                    alt="Inkasso log"
                    style={{ height: "50px", marginBottom: "10px", filter: "brightness(0) invert(0)" }}
                    className="navbar-brand-light"
                  />
                </div>
              </div>




              <NavItem title={t("sidebar.overview")} link={RoutesCustom.ClientDashboardOverview.url} icon={faChartPie} />
              <NavItem title={t("sidebar.uploadClaim")} link={RoutesCustom.UploadClaim.url} icon={faUpload} />
              <NavItem title={t("sidebar.allClaims")} link={RoutesCustom.Claims.url} icon={faFileAlt} />
                 <NavItem
                title={t("sidebar.messages")}
                link={RoutesCustom.Messages.url}
                icon={faInbox}
                badgeText={unreadClaims > 0 ? unreadClaims : null}
                badgeBg="danger"
                badgeColor="white"
              />
              {!isSubUser && (
                <NavItem title={t("sidebar.profile")} link={RoutesCustom.Profile.url} icon={faUser} />
              )}
              <NavItem title={t("sidebar.uploadMandate")} link={RoutesCustom.Mandate.url} icon={faUpload} />

              <NavItem title={t("sidebar.completed")} link={RoutesCustom.Completed2.url} icon={faCheckCircle} />

              {!isSubUser && (
                <NavItem title={t("sidebar.registerNewUsers")} link={RoutesCustom.ClientSignup.url} icon={faUserPlus} />
              )}
           
              <NavItem title={t("feedback")} link={RoutesCustom.FeedbackClient.url} icon={faCheckCircle} />


              {/* Connect Accounting */}
              {/* <CollapsableNavItem eventKey="connect-accounting" title="Connect Accounting" icon={faCog}>
                <NavItem title="Lexware Office" link={RoutesCustom.Lexware.url} icon={faBook} />
                <NavItem title="sevdesk" link={RoutesCustom.Sevdesk.url} icon={faBoxOpen} />
                <NavItem title="FastBill" link={RoutesCustom.FastBill.url} icon={faFileAlt} />
                <NavItem title="Xentral" link={RoutesCustom.Xentral.url} icon={faRocket} />
                <NavItem title="Sage Active" link={RoutesCustom.SageActive.url} icon={faChartPie} />
                <NavItem title="Excel/CSV Upload" link={RoutesCustom.ExcelUpload.url} icon={faUpload} />
                <NavItem title="View All" link={RoutesCustom.SageActive.url} icon={faBars} />
              </CollapsableNavItem> */}

            </Nav>

            {/* logout at bottom */}
            <div className="mt-auto">

              <Dropdown.Divider className="my-3 border-indigo" />
              <Nav className="flex space-between">
                <NavItem title={t("sidebar.logout")} onClick={handleLogout} icon={faSignOutAlt} />

              </Nav>
            </div>
          </div>
        </SimpleBar>
      </CSSTransition>


    </>
  );
};
